module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-ThinItalic.7e385488.woff2";